'use client';

import { c as _c } from "react/compiler-runtime";
import { type GetThesesRow, useActiveWallet, useAuth, type useGetThesesInfinite } from '@morfi/backend-sdk-v2/client';
import { useTranslations } from 'next-intl';
import { ThesesEmpty } from '@/components/portfolio/empty-states/theses-empty';
import { ThesisFeed } from '@/components/social/debate/thesis-feed';
import type { ThesisItem } from '@/components/social/types';
export function PortfolioThesesContent(t0) {
  const $ = _c(20);
  const {
    query,
    rows,
    isOwn
  } = t0;
  const t = useTranslations("social");
  const {
    isAuthenticated
  } = useAuth();
  const {
    activeWallet
  } = useActiveWallet();
  if (!query.isPending && !query.isError && rows.length === 0 && query.hasNextPage !== true) {
    let t1;
    if ($[0] !== isOwn) {
      t1 = <ThesesEmpty isOwn={isOwn} unframed={true} />;
      $[0] = isOwn;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  const theses = rows as unknown as ThesisItem[];
  const t1 = query.hasNextPage === true;
  let t2;
  if ($[2] !== query) {
    t2 = () => {
      query.fetchNextPage();
    };
    $[2] = query;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== query.isFetchingNextPage || $[5] !== query.isPending || $[6] !== t1 || $[7] !== t2) {
    t3 = {
      isLoading: query.isPending,
      hasNextPage: t1,
      isFetchingNextPage: query.isFetchingNextPage,
      fetchNextPage: t2,
      pageCount: 0
    };
    $[4] = query.isFetchingNextPage;
    $[5] = query.isPending;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = activeWallet?.address ?? null;
  let t5;
  if ($[9] !== t) {
    t5 = t("theses_empty_title");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("theses_empty_user");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== isAuthenticated || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== theses) {
    t7 = <ThesisFeed theses={theses} pagination={t3} isAuthenticated={isAuthenticated} userId={t4} emptyTitle={t5} emptyDescription={t6} variant="debate" showMarketLink={true} />;
    $[13] = isAuthenticated;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = theses;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}